import { useMutation } from "@apollo/client";
import styled from "@emotion/styled";
import React from "react";
import { i18n, openCallMeModalWithAction, RootState, useAppDispatch, useAppSelector } from "src/common";
import { sendPolicyCancelationEmail } from 'src/common/api/apollo/supplementary';
import { colors } from "src/theme";
import { Button, Text } from "..";

const InfoCardStyle = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  background: "#1018280D",
  borderRadius: 8,
  padding: 8,

  '@media (max-width: 768px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start', 
    gap: 2,
    marginBottom: 0,
  },
});

export const CancelPolicyInfoCard = () => {
  const customer = useAppSelector((state: RootState) => state.model.customer.data);
  // The server takes the recipient from the SO, so the SO id is all we send.
  const { soIdWeb, soId } = useAppSelector((state: RootState) => state.model.offer);
  const activeSoId = soIdWeb ?? soId;

  const [sendPolicyCancelationEmailMutation] = useMutation(sendPolicyCancelationEmail);

  const dispatch = useAppDispatch();
  if (customer.hasPolicy === false) return null;

  // Without an SO there is nothing to attach the email to, but the callback
  // request itself is still worth having — open the modal with no email action
  // rather than hiding the CTA.
  const requestCall = () => dispatch(openCallMeModalWithAction(
    activeSoId
      ? () => { sendPolicyCancelationEmailMutation({ variables: { soId: activeSoId } }).catch(() => undefined); }
      : () => undefined
  ));

  return (
    <InfoCardStyle>
      <Text type="small" color={colors.text2}>
        {i18n.t('components.cards.cancelPolicyInfoCard.text')}
      </Text>
      <Button btnType="textPrimary" size="small" text="Zatraži poziv" onClick={requestCall} />
    </InfoCardStyle>
  )
}